import type { GTMEventReturnType } from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';

type PaneLocation = 'filter' | 'map';

interface GTMOverviewFilterPaneCloseReturnType extends GTMEventReturnType {
    pane_location: PaneLocation;
}

interface GTMOverviewFilterPaneCloseData {
    location: PaneLocation;
}

export default class GTMOverviewFilterPaneCloseModel extends GTMBaseModel {
    public static parseToGTMData({
        location
    }: GTMOverviewFilterPaneCloseData): GTMOverviewFilterPaneCloseReturnType {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'web_event',
            ga4_event_name: 'overview_filter_pane_close',
            pane_location: location
        };
    }
}
